/** @file One status line saying where animatable edits land: the setup pose or keys at the playhead frame. */
import type { Translate } from '@pose2d/i18n/types';
import type { EditTarget } from './rigView';

/** Props of TargetLine; `extra` is appended (already translated), e.g. "keyed here". */
export interface TargetLineProps {
  t: Translate;
  target: EditTarget;
  extra?: string;
}

/** Shown by the Draw Order and Constraints panels above their animatable fields. */
export function TargetLine({ t, target, extra }: TargetLineProps) {
  const text = target.kind === 'key' ? t('panels.rig.keying', { frame: target.frame }) : t('panels.rig.setup');
  return <p className="rig-hint">{extra === undefined ? text : `${text} · ${extra}`}</p>;
}
